'use strict';
var parent = require('../../stable/set/symmetric-difference');
require('../../modules/esnext.set.symmetric-difference.v2');

module.exports = parent;
